module.exports = "<div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable styles\">\r\n  {{alert.message}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/alert/alert.component.html
// module id = ./src/app/shared/components/alert/alert.component.html
// module chunks = main